export var SIDER_MENU_COLLAPSED_WIDTH = '64px';
export var HEADER_HEIGHT = '60px';
//# sourceMappingURL=const.js.map